import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { useCurrentPage } from '../../common/hooks/useCurrentPage';
import { helpCenterSlice } from '../../common/reducers/helpCenter';
import { pageToPresentedState } from '../../routes/appRoutes';

export const usePresentedState = () => {
  const dispatch = useDispatch();
  const currentPage = useCurrentPage();

  useEffect(() => {
    const presentedState = pageToPresentedState[currentPage];
    dispatch(helpCenterSlice.actions.setPresentedState(presentedState));
  }, [dispatch, currentPage]);
};
